import { render, staticRenderFns } from "./sidebar-panel.vue?vue&type=template&id=532fb7f6&scoped=true&"
import script from "./sidebar-panel.vue?vue&type=script&lang=ts&"
export * from "./sidebar-panel.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar-panel.vue?vue&type=style&index=0&id=532fb7f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532fb7f6",
  null
  
)

export default component.exports